export const GET_CHANGED_PARAMETER_LIST_V2 = 'hierarchy/heading/changedparameterlist/GET_CHANGED_PARAMETER_LIST_V2';
export const GET_CHANGED_PARAMETER_LIST_V2_REQUEST = 'hierarchy/heading/changedparameterlist/GET_CHANGED_PARAMETER_LIST_V2_REQUEST';
export const ERROR_STATUS_UPDATE = 'overview/ERROR_STATUS_UPDATE';

export const MAX_DAYS_RANGE = 90;
export const PRESELECTED_DAYS = 90;
export const ITEMS_PER_PAGE = 10;
